import { Divider } from "components/design/Divider";
import { TickSlim } from "components/icons/TickSlim";
import { AddonData } from "store/slices/addons";

type SubscriptionCardsProps = {
  plan?: string;
  features?: { description: string; active: boolean }[];
  price?: number | string;
  billingCycle?: string;
  title: string;
  onManage: (addon: AddonData) => void;
  addon?: AddonData;
};

export const SubscriptionCards = ({
  plan,
  features,
  price = 0,
  billingCycle = "month",
  title,
  onManage,
  addon,
}: SubscriptionCardsProps) => {
  return (
    <section className="t-flex t-flex-col t-gap-2">
      <div className="t-flex t-gap-5 t-w-full t-items-center">
        <div className="t-text-caption-italic t-text-neutral-50">{title}</div>
        <div className="t-w-1/2">
          <Divider />
        </div>
      </div>
      <div className="t-flex t-flex-col t-gap-1 t-rounded-lg t-p-1 t-w-full t-h-auto t-border t-border-solid t-border-neutral-0">
        <div className="t-flex t-justify-between t-gap-1 t-bg-plan-gradient t-p-3 t-rounded-lg">
          <div className="t-flex t-flex-col t-gap-1 t-w-1/2">
            <div className="t-text-subtitle t-leading-normal t-text-text-100">
              {plan}
            </div>
            <div className="t-text-body-sm t-text-neutral">
              <span>${price}</span>
              <span className="t-text-caption">/{billingCycle}</span>
            </div>
          </div>
          <div className="t-flex t-flex-col t-gap-2 t-w-1/2">
            {features &&
              features.map((feature) => (
                <div
                  key={feature.description}
                  className="t-flex t-items-center t-gap-2"
                >
                  <div className="t-text-purple t-flex t-items-center">
                    <TickSlim />
                  </div>
                  <div className="t-text-caption t-leading-normal  t-text-text-60">
                    {feature.description}
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div
          onClick={() => onManage(addon!)}
          className="t-text-subtext-sm t-text-purple t-p-2 t-cursor-pointer"
        >
          Manage plan
        </div>
      </div>
    </section>
  );
};
